import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Unlocked = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      ref={forwardedRef}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00122 2.5C6.75858 2.5 5.75122 3.50736 5.75122 4.75V6.5H11.5034C12.3318 6.5 13.0034 7.17157 13.0034 8V12.5C13.0034 13.3284 12.3318 14 11.5034 14H4.50391C3.67548 14 3.00391 13.3284 3.00391 12.5V8C3.00391 7.17157 3.67548 6.5 4.50391 6.5H4.75122V4.75C4.75122 2.95507 6.2063 1.5 8.00122 1.5C9.48959 1.5 10.7431 2.50007 11.1288 3.86392C11.204 4.12964 11.0495 4.40597 10.7838 4.48113C10.5181 4.55628 10.2417 4.4018 10.1666 4.13608C9.8994 3.19143 9.03041 2.5 8.00122 2.5ZM4.50391 7.5C4.22776 7.5 4.00391 7.72386 4.00391 8V12.5C4.00391 12.7761 4.22776 13 4.50391 13H11.5034C11.7795 13 12.0034 12.7761 12.0034 12.5V8C12.0034 7.72386 11.7795 7.5 11.5034 7.5H4.50391ZM8.50122 9.5C8.50122 9.22386 8.27736 9 8.00122 9C7.72508 9 7.50122 9.22386 7.50122 9.5V11C7.50122 11.2761 7.72508 11.5 8.00122 11.5C8.27736 11.5 8.50122 11.2761 8.50122 11V9.5Z"
        color={color}
      />
    </svg>
  )
})

export default Unlocked
